
import React from 'react';

interface AvatarProps {
  size?: 'small' | 'large';
  className?: string;
}

export const ChatbotAvatar: React.FC<AvatarProps> = ({ size = 'small', className = '' }) => {
  return (
    <div className={`flex items-center justify-center overflow-hidden ${
      size === 'small' 
        ? 'h-8 w-8 rounded-full' 
        : 'chatbot-button-avatar h-full w-full'
    } ${className}`}>
      <img 
        src="/uploads/7f5b06e1-1d11-4dbb-999d-b1bf7635fa5f.png"
        alt="Manon"
        className="object-cover h-full w-full"
      />
    </div>
  );
};

export default ChatbotAvatar;
